import { API_VACANCY_URL } from '@/constants'
import { IPaginationParam, IPaginationResponse } from '@/types/pagination'
import { createAxiosInstance } from '@/utils'
const axios = createAxiosInstance({
  baseURL: API_VACANCY_URL,
  withAuth: true,
})
export const fetchBranchs = (params?: IPaginationParam) => {
  return axios
    .get<{ data: IPaginationResponse<IBranch> }>('/branch', {
      params,
    })
    .then((response) => response.data.data)
}
